import React from 'react';

const ModerationStatsBar = ({ stats, totalCount }) => {
  const items = [
    { label: 'TOTALT', value: totalCount || 0, color: '#3B6FD4' },
    { label: 'VENTER', value: stats?.pending || 0, color: '#E9C46A' },
    { label: 'GODKJENT', value: stats?.approved || 0, color: '#2EC4A0' },
    { label: 'AVVIST', value: stats?.rejected || 0, color: '#E76F51' },
    { label: 'FLAGGET', value: stats?.flagged || 0, color: '#F97316' }
  ];

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '12px', marginBottom: '32px' }}>
      {items?.map(item => (
        <div key={item?.label} style={{ background: '#0D1520', border: `1px solid ${item?.color}22`, padding: '20px 16px', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '2px', background: item?.color }} />
          <p style={{ fontFamily: 'Impact, sans-serif', fontSize: '2rem', color: item?.color, margin: '0 0 4px', letterSpacing: '-0.02em' }}>{item?.value}</p>
          <p style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.55rem', color: 'rgba(138,149,163,0.6)', letterSpacing: '0.15em', margin: 0 }}>{item?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default ModerationStatsBar;
